import { getDocument, GlobalWorkerOptions, version } from 'pdfjs-dist'

// Configure PDF.js worker (same as PDFViewer.tsx)
GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.mjs`

const MAX_TEXT_LENGTH = 50000

/**
 * Extract text content from a PDF file
 * @param arrayBuffer - The PDF file as an ArrayBuffer
 * @returns Extracted text from all pages
 */
export async function extractTextFromPdf(arrayBuffer: ArrayBuffer): Promise<string> {
  const pdf = await getDocument({ data: arrayBuffer }).promise
  const textParts: string[] = []

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum)
    const textContent = await page.getTextContent()
    const pageText = textContent.items
      .filter((item) => 'str' in item)
      .map((item) => (item as { str: string }).str)
      .join(' ')
    textParts.push(pageText)
  }

  let fullText = textParts.join('\n\n')

  // Truncate if necessary
  if (fullText.length > MAX_TEXT_LENGTH) {
    const truncated = fullText.slice(0, MAX_TEXT_LENGTH)
    const lastSpace = truncated.lastIndexOf(' ')
    fullText =
      truncated.slice(0, lastSpace > 0 ? lastSpace : MAX_TEXT_LENGTH) +
      '\n\n[Text truncated due to length...]'
  }

  return fullText
}
